import { render, staticRenderFns } from "./OverView.vue?vue&type=template&id=04545863&scoped=true&"
import script from "./OverView.vue?vue&type=script&lang=js&"
export * from "./OverView.vue?vue&type=script&lang=js&"
import style0 from "./OverView.vue?vue&type=style&index=0&id=04545863&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04545863",
  null
  
)

export default component.exports